import styled from 'styled-components';

export const SearchResults = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translateY(100%);
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.grey300};
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 10px 45px 0 rgba(14, 40, 83, 0.07);
  padding: 8px;
  z-index: 99;
  max-height: 300px;
  overflow-y: auto;
`;

export const EmptyResults = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 100%;
  transform: translateY(100%);
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.grey300};
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 10px 45px 0 rgba(14, 40, 83, 0.07);
  padding: 12px;
  z-index: 99;

  > svg {
    height: 40%;
  }

  > p {
    color: ${({ theme }) => theme.color.grey900};
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    margin-left: 12px;
  }
`;

export const ResultsItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 8px;
  margin-bottom: 4px;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.color.grey100};
  }

  > svg {
    min-width: 24px;
    min-height: 24px;
    width: 24px;
    height: 24px;
    color: ${({ theme }) => theme.color.grey500};
  }

  > div {
    margin-left: 8px;
  }
`;

export const MainPatientInfo = styled.p`
  color: ${({ theme }) => theme.color.grey800};
  font-family: Mulish;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22.4px;
  letter-spacing: 0.04px;
`;

export const PatientInfo = styled.p`
  color: ${({ theme }) => theme.color.grey600};
  font-family: Mulish;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  letter-spacing: 0.035px;
`;
